module.exports = __webpack_public_path__ + "static/media/lcevc.7724d872.png";